module.exports = __webpack_public_path__ + "static/img/dn1-mayor.4dc5bc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dn1-mayor.png
// module id = Npr2
// module chunks = 0